import { useState } from 'react'
import { Dialog } from 'radix-ui'
import { useCreateProduct } from '@/features/product/hooks'
import { formatError, PRODUCT_CODE_REGEX } from './formatError'

export function CreateProductDialog({ onClose }: { onClose: () => void }) {
  const create = useCreateProduct()
  const [code, setCode] = useState('')
  const [labelPl, setLabelPl] = useState('')
  const [error, setError] = useState<string | null>(null)

  const submit = () => {
    setError(null)
    if (!PRODUCT_CODE_REGEX.test(code)) {
      setError('Kod: małe litery, cyfry, podkreślenia. Musi zaczynać się od litery.')
      return
    }
    if (!labelPl.trim()) { setError('Nazwa nie może być pusta.'); return }
    create.mutate(
      { code, labelPl, sortOrder: 100, isActive: true },
      { onSuccess: onClose, onError: e => setError(formatError(e)) },
    )
  }

  return (
    <Dialog.Root open onOpenChange={o => { if (!o) onClose() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-5 w-[460px] shadow-xl">
          <Dialog.Title className="text-base font-semibold">Nowy produkt (element)</Dialog.Title>
          <Dialog.Description className="text-xs text-slate-500 mt-1">
            Element umowy (fotowoltaika, magazyn, wiatrak...). Po utworzeniu wejdź w Edytuj, żeby zdefiniować etapy.
          </Dialog.Description>

          <div className="mt-4 flex flex-col gap-3 text-sm">
            <label className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">Kod</span>
              <input
                value={code}
                onChange={e => setCode(e.target.value.toLowerCase())}
                disabled={create.isPending}
                className="border rounded px-2 py-1 font-mono"
                placeholder="fotowoltaika"
              />
            </label>
            <label className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">Nazwa</span>
              <input value={labelPl} onChange={e => setLabelPl(e.target.value)} disabled={create.isPending} className="border rounded px-2 py-1" />
            </label>

            {error && <p className="text-red-600 text-xs">{error}</p>}

            <div className="flex justify-end gap-2 mt-2">
              <button type="button" onClick={onClose} className="px-3 py-1.5 border rounded" disabled={create.isPending}>Anuluj</button>
              <button type="button" onClick={submit} className="px-3 py-1.5 bg-sky-600 text-white rounded disabled:opacity-50" disabled={create.isPending}>
                {create.isPending ? 'Tworzenie...' : 'Utwórz'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
